import React from 'react';

const AnchorContext = React.createContext({
    registerAnchorId: (id: string) => {}
});

export default AnchorContext;